import { useAuth } from 'context/useAuth';
import { useEffect, useState } from 'react';
import { where } from 'firebase/firestore';
import { useCollection } from './useCollection';
import { Installation } from 'types/Installation';

export default function useGetInstallations(filters?: string, filterData: any = {}) {
  
  const { authorisedUser } = useAuth();
  const [error, setError] = useState('');
  const [installations, setInstallations] = useState<Installation[]>([]);
  const [loadingInstallations, setLoadingInstallations] = useState(false);
  const installationsCollection = useCollection<Installation>('installations');
  
  useEffect(() => {
    let cancelled = false;
    async function getInstallations() {
      
      setLoadingInstallations(true);

      try {
        
        let installations: Installation[] = [];
        
        if (filterData.installationId !== '@new') {
          switch (filters) {
            
            case 'ALL':
              installations = (await installationsCollection.queryMany()).map(({ id, data }) => { data.id = id; return data; });
              break;

            case 'BY_ID':
              installations = (await installationsCollection.queryMany([where("__name__", "==", filterData.installationId)])).map(({ id, data }) => { data.id = id; return data; });
              break;
              
            default:
              const message = `Filter not handled : ${filters}`;
              console.error(message);
              alert(message);
          }
        }

        if (cancelled) return;
        setInstallations(installations);

      } catch (error: any) {
        if (cancelled) return;
        //if (axios.isAxiosError(error)) {
          setError(error.message);
        //}
      } finally {
        if (!cancelled) {
          setLoadingInstallations(false);
          sortInstallations('');
        }
      }
    }
    getInstallations();
    return () => { cancelled = true; };
  }, [authorisedUser.accessToken, filters, installationsCollection, filterData.installationId]);

  function sortInstallations(label: string) {
    switch (label) {
      case 'A - Z':
        setInstallations((prevState) => {
          return prevState.sort((a, b) =>
            (a.id || '').localeCompare(b.id || '')
          );
        });
        break;
      case 'Z - A':
        setInstallations((prevState) => {
          return prevState.sort((a, b) =>
            (b.id || '').localeCompare(a.id || '')
          );
        });
        break;
      default:
        setInstallations((prevState) => {
          return [...prevState].sort((a, b) => {
            const aTime = a.dateStarted?.toMillis?.() ?? a.audit?.createdAt?.toMillis?.() ?? 0;
            const bTime = b.dateStarted?.toMillis?.() ?? b.audit?.createdAt?.toMillis?.() ?? 0;
            return bTime - aTime;
          });
        });
    }
  }

  return {
    installations,
    loadingInstallations,
    error,
    sortInstallations,
  };
}